import { user_role } from "../config/apiConfig";
import Api from "../utils/axios";

const AuthApi = {
  register: (payload) => Api.post(`auth/register`, payload),
  login: (payload) => Api.post(`auth/login/${user_role.vendor}`, payload),
  loginWithGoogleProvider: (payload) =>
    Api.post(`auth/login/${user_role.vendor}`, payload),
  updateUser: (payload) =>
    Api.put(`auth/update-account`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateCoverImage: (payload) =>
    Api.put(`auth/update-cover-image`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  currentUser: () => Api.get(`auth/current-user`),
  generateAccessToken: (payload) => Api.post("auth/refresh-token", payload),
  logoutUser: () => Api.post("auth/logout"),

  generateOtp: (payload) => Api.post("auth/generate-otp", payload),
  verfiryOtp: (payload) => Api.post("auth/verify-otp", payload),
  sendOtp: (payload) => Api.post("auth/send-otp", payload),
  sendPhoneVerificationOtp: (payload) => Api.post("auth/send-phone-verification-otp", payload),
  verifyPhoneVerificationOtp: (payload) => Api.post("auth/verify-phone-verification-otp", payload),
  sendEmailVerificationOtp: (payload) => Api.post("auth/send-email-verification-otp", payload),
  verifyEmailVerificationOtp: (payload) => Api.post("auth/verify-email-verification-otp", payload),
  resetPassword: (payload) => Api.post("auth/reset-password", payload),
  referralCode: (payload) => Api.post(`auth/check-referral-code`, payload),
  // change-password
};

export default AuthApi;
